import * as yup from 'yup';
import YupValidationErrors from '@/Utils/YupValidationErrors';

export const isUrl = (value: string) =>
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g.test(value);

export const linkedInFormSchema = yup.object({
    linkedInId: yup
        .string()
        .required(YupValidationErrors.Required)
        .test('is-http-protocol', YupValidationErrors.UrlMustBeFromLinkedIn, (value) => {
            if (value && isUrl(value)) {
                let url: URL;
                try {
                    url = new URL(value);
                } catch {
                    if (URL.canParse(`https://${value}`)) {
                        url = new URL(`https://${value}`);
                    } else {
                        return false;
                    }
                }

                return url.protocol === 'http:' || url.protocol === 'https:';
            }

            return true;
        })
        .test('is-linkedin-profile-url', YupValidationErrors.UrlMustBeFromLinkedIn, (value) => {
            if (value && isUrl(value)) {
                let url: URL;
                try {
                    url = new URL(value);
                } catch {
                    if (URL.canParse(`https://${value}`)) {
                        url = new URL(`https://${value}`);
                    } else {
                        return false;
                    }
                }

                return url.hostname === 'www.linkedin.com' && url.pathname.startsWith('/in/');
            }

            return true;
        }),
});

export type LinkedInFormSchema = yup.InferType<typeof linkedInFormSchema>;
